module.exports = __webpack_public_path__ + "static/img/case3.28a3c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/case3.png
// module id = VRZd
// module chunks = 19